export default "__VITE_ASSET__CHnyXbct__"